export enum EarningsTypeEnum {
  SELLER = "seller",
  CLOSER = "mentor",
  UPLINE = "upline",
  REBATE = "financeRebate",
}

export enum EarningsAnalyticsTimeFrameEnum {
  THIS_WEEK = "this_week",
  LAST_WEEK = "last_week",
  THIS_MONTH = "this_month",
  LAST_MONTH = "last_month",
  QUARTER = "quarter",
  YEAR_TO_DATE = "year_to_date",
}

export enum EarningsEngineEnum {
  COMMISSIONS = "commissions",
  GENERATIONAL = "generational",
  DIFFERENTIAL = "differential",
  LDB = "ldb",
  CONSISTENCY = "consistency",
}

export enum ProjectEarningsRoleEnum {
  SELLER = "seller",
  CLOSER = "closer",
  UPLINE = "upline",
  OWNER = "owner",
}
